// extracted by mini-css-extract-plugin
export default {"CotizarBtn":"CotizarBtn_CotizarBtn__6cxsu"};